export const Configuracion = {
    url1: "https://service2.rakler.pe/SisAcopio/",
    url_iconos1:'https://service2.rakler.pe/SisAcopio/assets/iconos/',
    url2: "https://service2.rakler.pe/autentica/",
    url_iconos2:'https://service2.rakler.pe/autentica/assets/iconos/',
}